import { openPopup, subscribeToMessages } from 'src/lib/popup';

interface AuthData {
  errorMessage?: string;
  [key: string]: unknown;
}

const POPUP_OPTIONS = {
  name: 'oauth-popup',
  width: 600,
  height: 800,
};

export const openOAuthPopup = (authUrl: string, popupOptions = {}) =>
  new Promise((resolve, reject) => {
    const resultHandler = (authData?: AuthData) => {
      if (popup) {
        popup.close();
      }

      if (!authData) {
        reject();
        return;
      }

      if (authData.errorMessage) {
        reject(new Error(authData.errorMessage));
        return;
      }

      resolve(authData);
    };

    // Listen for message from popup
    const unsubscribeFromMessages = subscribeToMessages(
      (data: AuthData) => {
        unsubscribeFromMessages();
        resultHandler(data);
      },
      { ...POPUP_OPTIONS, ...popupOptions }
    );

    // Open Google auth popup
    const popup = openPopup(authUrl, { ...POPUP_OPTIONS, ...popupOptions });

    if (!popup) {
      reject(new Error('Cannot open pop-up. Redirecting…'));
      unsubscribeFromMessages();
      return;
    }
    popup.focus();

    // Run a timer, to check if popup was closed by user, and hasn't sent a message
    const timer = setInterval(() => {
      if (!popup.closed) {
        return;
      }

      clearInterval(timer);
      unsubscribeFromMessages();
      resultHandler();
    }, 100);
  });
